import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from "@angular/router";
import {NgRedux} from "@angular-redux/store";
import {Observable} from "rxjs/Observable";
import {IUser} from "../../shared/redux-store/session/session.types";
import {IAppState} from "../../shared/redux-store/store";
import {VisBosGuard} from "../../core/visbos-core/authorization/guards/visbos.guard";
import {SessionActions} from "../../shared/actions/session.actions";
import {hasPermissionTo} from "../../core/visbos-core/authorization/guards/has-permission-to.guard";

@Injectable()
export class EStoreMigrationGuard extends VisBosGuard implements CanActivate, CanActivateChild {

  constructor(router: Router, siActions: SessionActions, ngRx: NgRedux<IAppState>) {
    super(router, siActions, ngRx);
  }

  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return hasPermissionTo(this.ngRx, 'migrate eStore');
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/guards/estore-migration.guard.ts